import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import _ from 'lodash';
import { Button } from '@nerdwallet/currency';

import PressCategory from '../press-category/press-category';

const PressArchive = ({ articles, className, link }) => {
  if (_.isEmpty(articles)) {
    return null;
  }

  return (
    <div className={classNames('press-archive', className)}>
      <PressCategory articles={articles} />
      <div
        className={classNames([
          'press-archive__btn',
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
          classes('text-align-center'),
        ])}
      >
        <Button primary href={link}>
          See more
        </Button>
      </div>
    </div>
  );
};

PressArchive.propTypes = {
  className: PropTypes.string,
  articles: PropTypes.array.isRequired,
  link: PropTypes.string,
};

PressArchive.displayName = 'PressArchive';

export default PressArchive;
